import React, { useEffect, useRef, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, Input, Label, FormGroup } from 'reactstrap';
import ConfirmCloseModal from '../Common/ConfirmCloseModal';
import ErrorAlert from '../Common/ErrorAlert';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import ImageUploader from '../Common/ImageUploader';
import Select from "react-select";
import { useDispatch, useSelector } from 'react-redux';
import {
    getLegacyPatentes,
    getLegacyPersonas,
    getLegacyTiposTrabajoOt
} from '../../slices/thunks';
import LoadingOverlay from '../Common/LoadingOverlay';
import ModalFormVehiculo from './ModalFormVehiculo';
import SignaturePad from '../SignaturePad';
import VehicleDamageForm from '../Common/VehicleDamageForm';
import FractionSlider from '../Common/FractionSlider';
import useMantenciones from '../Hooks/useMantenciones';
import useCreateVehiculo from '../Hooks/useCreateVehiculo';
import ContactSection from './sections/ContactSection';
import InventorySection from './sections/InventorySection';
import DamageSection from './sections/DamageSection';
import SignatureSection from './sections/SignatureSection';
import { getClienteById } from '../../helpers/api_helper';
import { resetLegacyPatentes } from '../../slices/legacyPatentes/reducer';


const ModalCrearRecepcionVehiculo = ({ isOpen, toggle, onSave, citaPrecargada, validationError }) => {
    const tenantId = useSelector((state) => state.Context.tenantId)
    const empresa = useSelector((state) => state.Context.empresa)
    const departamento = useSelector((state) => state.Context.departamento)
    const userInfo = useSelector((state) => state.UserInfo.userInfo)

    const modalContentRef = useRef(null);
    const [generandoPdf, setGenerandoPdf] = useState(false);
    const [saving, setSaving] = useState(false);
    const [saveMessage, setSaveMessage] = useState('');
    const [isDirty, setIsDirty] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [activeStep, setActiveStep] = useState(0);

    const [tipoTrabajoOt, setTipoTrabajoOt] = useState({})
    const [selectQuienRetira, setSelectQuienRetira] = useState({ value: 'propietario', label: 'Propietario' })
    const [selectedMantencion, setSelectedMantencion] = useState(null);

    const [ownerRutValidation, setOwnerRutValidation] = useState('pending');
    const ownerRutAbortRef = useRef(null);
    const [patenteLookupResult, setPatenteLookupResult] = useState('pending');
    const [showPatenteError, setShowPatenteError] = useState(false);
    const [patenteError, setPatenteError] = useState('');
    const [contactErrors, setContactErrors] = useState({});
    const [inventoryError, setInventoryError] = useState('');
    const [damageError, setDamageError] = useState('');

    const timeoutRef = useRef(null);

    const patentes = useSelector((state) => state.LegacyPatentes.legacyPatentes)
    const patentesIsLoading = useSelector((state) => state.LegacyPatentes.loading)
    const personas = useSelector((state) => state.LegacyPersonas.legacyPersonas)
    const personasIsLoading = useSelector((state) => state.LegacyPersonas.loading)

    const tiposTrabajoOt = useSelector((state) => state.LegacyTiposTrabajoOt.legacyTiposTrabajoOt)

    const marca = patentes?.[0]?.MARCAS || null;
    const modelo = patentes?.[0]?.MODELO || null;

    const { mantenciones, loading: mantencionesLoading } = useMantenciones(marca, modelo);
    const { createVehiculo, loading: createVehiculoLoading } = useCreateVehiculo();

    const dispatch = useDispatch()

    const [formData, setFormData] = useState({
        patente: citaPrecargada && citaPrecargada.patente ? citaPrecargada.patente : '',
        rut_contacto: citaPrecargada && citaPrecargada.rut_contacto ? citaPrecargada.rut_contacto : personas && personas.length > 0 ? personas[0].RUT : '',
        contacto: citaPrecargada && citaPrecargada.contacto ? citaPrecargada.contacto : personas && personas.length > 0 ? personas[0].NOMBRE : '',
        email: citaPrecargada && citaPrecargada.email ? citaPrecargada.email : personas && personas.length > 0 ? personas[0].EMAIL : '',
        telefono: citaPrecargada && citaPrecargada.telefono ? citaPrecargada.telefono : personas && personas.length > 0 ? personas[0].TELEFONO : '',
        cita: citaPrecargada && citaPrecargada.cita ? citaPrecargada.cita : 0,
        tipo_trabajo_ot: citaPrecargada && citaPrecargada.tipo_trabajo_ot ? citaPrecargada.tipo_trabajo_ot : '',
        solicitud_cliente: citaPrecargada && citaPrecargada.solicitud_cliente ? citaPrecargada.solicitud_cliente : '',
        sin_inventario: false,
        sin_danos: false,
        sucio: false,
        nivel_estanque: 0,
        emisora_radio: "",
        inventario: {
            plumillas: null,
            radio: null,
            panel_radio: null,
            herramientas: null,
            gata: null,
            extintor: null,
            botiquin: null,
            permiso_circulacion: null,
            libro_garantia: null,
            encendedor: null,
            accesorios: null,
            neumatico_repuesto: null,
            tapa_rueda: null,
            cubre_pisos: null,
            observaciones: '',
        },
        danos: [],
        danos_img: '',
        firma_cliente: '',
        firma_recepcionista: '',
        nombre_recepcionista: userInfo && userInfo.displayName ? userInfo.displayName : '',
        imagenes: [],
        quien_retira: personas && personas.length > 0 ? personas[0].NOMBRE : ''
    });

    useEffect(() => {
        if (userInfo && userInfo.displayName) {
            setFormData(prevData => ({
                ...prevData,
                ['nombre_recepcionista']: userInfo.displayName
            }));
        }
    }, [userInfo])

    useEffect(() => {
        if (citaPrecargada && citaPrecargada.patente) {
            dispatch(getLegacyPatentes({ tenantId, patente: citaPrecargada.patente, empresa }))
        }


        if (citaPrecargada && citaPrecargada.tipo_trabajo_ot)
            setTipoTrabajoOt(parseTiposTrabajoOt(buscarTipoTrabajoOt(citaPrecargada.tipo_trabajo_ot)))
        else
            setTipoTrabajoOt(parseTiposTrabajoOt(tiposTrabajoOt[0]))


    }, [citaPrecargada])

    useEffect(() => {
        if (patentesIsLoading) {
            setPatenteLookupResult('loading');
            return;
        }
        if (Array.isArray(patentes) && patentes.length > 0) {
            setPatenteLookupResult('found');
            setShowPatenteError(false);
            return;
        }
        if (formData.patente && formData.patente.length >= 5) {
            setPatenteLookupResult('not_found');
            return;
        }
        setPatenteLookupResult('pending');
        setShowPatenteError(false);
    }, [patentes, patentesIsLoading, formData.patente]);

    useEffect(() => {
        if (selectQuienRetira && selectQuienRetira.value == 'propietario') {
            setFormData(prev => ({
                ...prev,
                ["quien_retira"]: personas && personas.length > 0 ? personas[0].NOMBRE : ''
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                ["quien_retira"]: ''
            }));
        }
    }, [selectQuienRetira])


    useEffect(() => {
        if (Array.isArray(patentes) && patentes.length > 0) {
            dispatch(getLegacyPersonas({ tenantId, rut: patentes[0]?.CLIENT || '', empresa }))
        }
    }, [patentes])

    useEffect(() => {
        const ownerRut = patentes?.[0]?.CLIENT;

        if (ownerRutAbortRef.current) {
            ownerRutAbortRef.current.abort();
        }

        if (!ownerRut) {
            setOwnerRutValidation('pending');
            return;
        }

        const controller = new AbortController();
        ownerRutAbortRef.current = controller;

        const validateOwnerRut = async () => {
            try {
                const response = await getClienteById(ownerRut, { tenantId, signal: controller.signal });
                if (controller.signal.aborted) return;

                if (response?.CLIPRO) {
                    setOwnerRutValidation('valid');
                } else {
                    setOwnerRutValidation('invalid');
                }
            } catch (error) {
                if (controller.signal.aborted) return;
                setOwnerRutValidation('error');
            }
        };

        validateOwnerRut();

        return () => {
            controller.abort();
        };
    }, [patentes?.[0]?.CLIENT, tenantId]);

    useEffect(() => {
        if (tiposTrabajoOt.length === 0)
            dispatch(getLegacyTiposTrabajoOt({ tenantId, empresa }))
    }, [tiposTrabajoOt])


    useEffect(() => {
        if (Array.isArray(personas) && personas.length > 0) {
            setFormData(prev => ({
                ...prev,
                ["rut_contacto"]: citaPrecargada?.rut_contacto || personas[0].CLIPRO || '',
                ["contacto"]: citaPrecargada?.contacto || personas[0].CONTAC || '',
                ["email"]: citaPrecargada?.email || personas[0].CEMAIL || '',
                ["telefono"]: citaPrecargada?.telefono || personas[0].NFONO1 || '',
                ["quien_retira"]: citaPrecargada?.contacto || personas[0].CONTAC || ''
            }));

        }
    }, [personas])

    useEffect(() => {
        if (isOpen) {
            const hasPrecarga = citaPrecargada && citaPrecargada.patente;
            setIsDirty(!!hasPrecarga);
            setSaveMessage('');
            setOwnerRutValidation('pending');
            setPatenteLookupResult('pending');
            setShowPatenteError(false);
            setPatenteError('');
            setContactErrors({});
            setInventoryError('');
            setDamageError('');
            setActiveStep(0);
            setFormData({
                patente: citaPrecargada && citaPrecargada.patente ? citaPrecargada.patente : '',
                rut_contacto: citaPrecargada && citaPrecargada.rut_contacto ? citaPrecargada.rut_contacto : personas && personas.length > 0 ? personas[0].RUT : '',
                contacto: citaPrecargada && citaPrecargada.contacto ? citaPrecargada.contacto : personas && personas.length > 0 ? personas[0].NOMBRE : '',
                email: citaPrecargada && citaPrecargada.email ? citaPrecargada.email : personas && personas.length > 0 ? personas[0].EMAIL : '',
                telefono: citaPrecargada && citaPrecargada.telefono ? citaPrecargada.telefono : personas && personas.length > 0 ? personas[0].TELEFONO : '',
                cita: citaPrecargada && citaPrecargada.cita ? citaPrecargada.cita : 0,
                tipo_trabajo_ot: citaPrecargada && citaPrecargada.tipo_trabajo_ot ? citaPrecargada.tipo_trabajo_ot : '',
                solicitud_cliente: citaPrecargada && citaPrecargada.solicitud_cliente ? citaPrecargada.solicitud_cliente : '',
                sin_inventario: false,
                sin_danos: false,
                sucio: false,
                nivel_estanque: 0,
                emisora_radio: "",
                inventario: {
                    plumillas: null,
                    radio: null,
                    panel_radio: null,
                    herramientas: null,
                    gata: null,
                    extintor: null,
                    botiquin: null,
                    permiso_circulacion: null,
                    libro_garantia: null,
                    encendedor: null,
                    accesorios: null,
                    neumatico_repuesto: null,
                    tapa_rueda: null,
                    cubre_pisos: null,
                    observaciones: '',
                },
                danos: [],
                danos_img: '',
                firma_cliente: '',
                firma_recepcionista: '',
                nombre_recepcionista: userInfo && userInfo.displayName ? userInfo.displayName : '',
                imagenes: [],
                quien_retira: personas && personas.length > 0 ? personas[0].NOMBRE : ''
            });
        } else {
            dispatch(resetLegacyPatentes());
        }
    }, [isOpen]);

    const handleInputChange = (e) => {
        setIsDirty(true);
        setSaveMessage('');
        if (e?.target) {
                    const { name, value, checked } = e.target;
            switch (name) {
                case 'patente':
                    let patente = value.trim().toUpperCase()
                    setFormData(prevData => ({
                        ...prevData,
                        [name]: patente
                    }));
            setOwnerRutValidation('pending');
            setPatenteLookupResult('pending');
            setShowPatenteError(false);
            setPatenteError('');
                    if (patente.length >= 5) {
                        if (timeoutRef.current) {
                            clearTimeout(timeoutRef.current)
                        }
                        timeoutRef.current = setTimeout(() => {
                            dispatch(getLegacyPatentes({ tenantId, patente, empresa }))
                        }, 300)
                    }
                    break
                case 'rut':
                    let rut = value.trim()
                    if (rut.length >= 5) {
                        formData.rut = rut
                    }
                    break
                default:
                    setFormData(prevData => ({
                        ...prevData,
                        [name]: value
                    }));
                    setContactErrors(prev => {
                        if (prev[name]) {
                            const next = { ...prev };
                            delete next[name];
                            return next;
                        }
                        return prev;
                    });
                    break;
            }
        }
    }

    const handleDanosChange = (data) => {
        if (Array.isArray(data)) {
            setFormData(prev => ({
                ...prev,
                danos: data
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                danos_img: data
            }));
        }
    };

    const handleSelectTiposTrabajoOt = (opcion) => {
        setTipoTrabajoOt(opcion);
        setFormData(prev => ({
            ...prev,
            tipo_trabajo_ot: opcion.value
        }));
    };

    function buscarTipoTrabajoOt(codigo) {
        let trabajoEncontrado = {}
        if (Array.isArray(tiposTrabajoOt) && tiposTrabajoOt.length > 0) {
            trabajoEncontrado = tiposTrabajoOt?.find(m => m.CODREG == codigo)
        }
        return trabajoEncontrado
    }

    const handleImagesChange = (nuevasImagenes) => {
        setFormData(prev => ({
            ...prev,
            imagenes: nuevasImagenes
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        setSaveMessage('');
        try {
            const result = await onSave(formData);
            if (result.success) {
                setSaveMessage('Recepción creada exitosamente.');
                setIsDirty(false);
                setTimeout(() => {
                    toggle();
                }, 2000);
            } else {
                setSaveMessage('Error al crear la recepción: ' + (result.error || 'Error desconocido'));
            }
        } catch (error) {
            setSaveMessage('Error al crear la recepción: ' + error.message);
        } finally {
            setSaving(false);
        }
    };

    const safeToggle = () => {
        if (saving || generandoPdf) return;
        if (isDirty) {
            setShowConfirm(true);
            return;
        }
        toggle();
    };

    const handleCancel = () => {
        if (saving || generandoPdf) return;
        if (isDirty) {
            setShowConfirm(true);
            return;
        }
        toggle();
    };

    const handleConfirmClose = () => {
        if (saving || generandoPdf) return;
        setShowConfirm(false);
        toggle();
    };

    const handleFuelChange = (fuelValue) => {
        setFormData(prev => ({
            ...prev,
            nivel_estanque: fuelValue
        }));
    };

    const handleSignatureClienteChange = (signatureData) => {
        setFormData(prev => ({
            ...prev,
            firma_cliente: signatureData
        }));
        console.log(formData)
    };

    const handleSignatureRecepcionistaChange = (signatureData) => {
        setFormData(prev => ({
            ...prev,
            firma_recepcionista: signatureData,
        }));
        console.log(formData)
    };

    function parseTiposTrabajoOt(tipo_trabajo_ot) {
        return { value: tipo_trabajo_ot?.CODREG, label: tipo_trabajo_ot?.DESCRI };
    }

    const parseMantenciones = (mantenciones) => {
        if (!Array.isArray(mantenciones)) return [];
        return mantenciones.map(m => ({
            value: m.clave,
            label: m.descri,
            data: m
        }));
    };

    const handleSelectMantencion = (opcion) => {
        setSelectedMantencion(opcion);
        setFormData(prev => ({
            ...prev,
            servicio: opcion ? opcion.value : ''
        }));
    };

    const [cameraOpen, setCameraOpen] = useState(false);

    const effectiveIsOpen = isOpen && !cameraOpen;

    const [modalModificarVehiculo, setModalModificarVehiculo] = useState(false)
    const toggleModalVehiculo = () => {
        setModalModificarVehiculo(!modalModificarVehiculo);
    };

    const handleModalModificarVehiculo = () => {
        setModalModificarVehiculo(true);
    }

    const [modalCrearVehiculo, setModalCrearVehiculo] = useState(false)
    const toggleModalCrearVehiculo = () => {
        setModalCrearVehiculo(!modalCrearVehiculo);
    };

    const handleModalCrearVehiculo = () => {
        setModalCrearVehiculo(true);
    }

    const handleGuardarVehiculo = async (formDataVehiculo) => {
        const transformedData = {
            CLAEMP: empresa,
            PATENT: formDataVehiculo.patente,
            MARCAS: formDataVehiculo.marca?.value,
            MODELO: formDataVehiculo.modelo?.value,
            NROVIN: formDataVehiculo.vin,
            NCHASI: formDataVehiculo.chasis,
            CCOLOR: formDataVehiculo.color?.value,
            COMBUS: formDataVehiculo.tipoCombustible?.value,
            TRACCI: formDataVehiculo.tipoTraccion?.value,
            TRASMI: formDataVehiculo.tipoTransmision?.value,
            ANOFAB: formDataVehiculo.ano,
            NMOTOR: formDataVehiculo.motor,
            CLIENT: formDataVehiculo.rut
        };

        const result = await createVehiculo(transformedData);

        if (result.success) {
            dispatch(getLegacyPatentes({ tenantId, patente: formDataVehiculo.patente, empresa }));
        } else {
            throw new Error(result.error || 'Error al crear vehículo');
        }
    };

    const handleVehiculoModificado = () => {
        if (Array.isArray(patentes) && patentes.length > 0) {
            dispatch(getLegacyPatentes({ tenantId, patente: patentes[0]?.PATENT, empresa }));
        }
    };

    return (
        <Modal isOpen={effectiveIsOpen} toggle={safeToggle} size="lg" backdrop="static">
            <div ref={modalContentRef} >
                <ModalHeader toggle={safeToggle}>
                    <i className="ri-car-line me-2"></i>
                    Recepción Vehículo {formData.patente ? ` - ${formData.patente}` : ''}
                </ModalHeader>
                <Form>
                    <ModalBody style={{ position: 'relative' }}>
                        <ModalFormVehiculo
                            mode="modify"
                            isOpen={modalModificarVehiculo}
                            toggle={toggleModalVehiculo}
                            onSave={handleVehiculoModificado}
                            selectedVehiculo={Array.isArray(patentes) && patentes.length > 0 ? patentes[0]?.PATENT : undefined}
                        />
                        <ModalFormVehiculo
                            mode="create"
                            isOpen={modalCrearVehiculo}
                            toggle={toggleModalCrearVehiculo}
                            onSave={handleGuardarVehiculo}
                            patente={formData.patente}
                        />

                        <LoadingOverlay loading={saving || generandoPdf} message={generandoPdf ? 'Generando PDF…' : 'Guardando recepción…'} />

                        {activeStep === 0 && (
                            <>
                                <div className="d-flex align-items-center my-2">
                                    <div className="flex-grow-1 border-top"></div>
                                    <span className="mx-3 text-muted fw-bold">Vehículo</span>
                                    <div className="flex-grow-1 border-top"></div>
                                </div>
                                {showPatenteError && (
                                    <ErrorAlert
                                        error="La patente no existe en el sistema. Cree el vehículo o verifique la patente ingresada."
                                        onDismiss={undefined}
                                    />
                                )}
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="patente">Patente</Label>
                                        <div className="row">
                                            <div className="col">
                                                <Input
                                                    type="text"
                                                    id="patente"
                                                    name="patente"
                                                    value={formData.patente}
                                                    onChange={handleInputChange}
                                                    placeholder="Ej: ABC123"
                                                    required
                                                    disabled={citaPrecargada && citaPrecargada.patente ? true : false}
                                                    invalid={!!patenteError}
                                                />
                                                {patenteError && (
                                                    <div className="text-danger small">{patenteError}</div>
                                                )}
                                            </div>
                                            {patentesIsLoading ?
                                                <div className="col">
                                                    <div><Label>Cargando...</Label></div>
                                                </div> : (
                                                    Array.isArray(patentes) && patentes.length > 0 ? (
                                                        <div className="col">
                                                            <button
                                                                className="btn btn-success"
                                                                onClick={handleModalModificarVehiculo}
                                                                style={{ whiteSpace: 'nowrap' }}
                                                            ><i className="ri-add-line me-1"></i> Modificar
                                                            </button>
                                                        </div>
                                                    ) : formData.patente && typeof formData.patente == 'string' && formData.patente.length > 4 ? (
                                                        <div className="col">
                                                            <button
                                                                className="btn btn-success"
                                                                onClick={handleModalCrearVehiculo}
                                                                style={{ whiteSpace: 'nowrap' }}
                                                            ><i className="ri-add-line me-1"></i> Crear
                                                            </button>
                                                        </div>
                                                    ) : "")}
                                        </div>

                                    </FormGroup>
                                </div>

                                <div className="row  align-items-end">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="odometro">Odómetro</Label>
                                            <Input
                                                type="number"
                                                id="odometro"
                                                name="odometro"
                                                value={formData.odometro}
                                                onChange={handleInputChange}
                                                placeholder={`Último registro: ${patentes[0]?.ULTLEM || '0'} km`}
                                                required
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="emisora_radio">Emisora radio</Label>
                                            <Input
                                                type="text"
                                                id="emisora_radio"
                                                name="emisora_radio"
                                                value={formData.emisora_radio}
                                                onChange={handleInputChange}
                                                placeholder="Ej: 88.1 FM"
                                                required
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row  align-items-end">

                                    <div className="col-6">

                                        <FormGroup>
                                            <Label for="tipo_trabajo">Tipo Trabajo</Label>
                                            <Select
                                                id="tipo_trabajo"
                                                placeholder="Seleccione..."
                                                value={tipoTrabajoOt}
                                                onChange={handleSelectTiposTrabajoOt}
                                                options={Array.isArray(tiposTrabajoOt) && tiposTrabajoOt.length > 0 ? tiposTrabajoOt?.map(parseTiposTrabajoOt) : []}
                                                onFocus={(e) => {
                                                    e.target.readOnly = true;
                                                }}
                                                isClearable 
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="nivel_combustible">Combustible</Label>
                                            <FractionSlider
                                                value={formData.nivel_estanque}
                                                onChange={handleFuelChange}
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">

                                    {tipoTrabajoOt?.value == 'MAN' && formData.patente && (
                                        <div className="col-6">
                                            <FormGroup>
                                                <Label for="servicio">Servicio</Label>
                                                {mantencionesLoading ? (
                                                    <div className="text-muted">Cargando mantenciones...</div>
                                                ) : mantenciones.length > 0 ? (
                                                    <Select
                                                        id="servicio"
                                                        name="servicio"
                                                        placeholder="Seleccione mantención..."
                                                        value={selectedMantencion}
                                                        onChange={handleSelectMantencion}
                                                        options={parseMantenciones(mantenciones)}
                                                        isClearable
                                                    />
                                                ) : (
                                                    <Input
                                                        type="text"
                                                        id="servicio"
                                                        name="servicio"
                                                        value={formData.servicio}
                                                        onChange={handleInputChange}
                                                        placeholder="No hay mantenciones disponibles"
                                                    />
                                                )}
                                            </FormGroup>
                                        </div>
                                    )}
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <FormGroup>
                                            <Label for="solicitud_cliente">Solicitud cliente</Label>
                                            <Input
                                                type="textarea"
                                                id="solicitud_cliente"
                                                name="solicitud_cliente"
                                                value={formData.solicitud_cliente}
                                                onChange={handleInputChange}
                                                rows="3"
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="d-flex align-items-start gap-3 mt-4">
                                    <button
                                        type="button"
                                        className="btn btn-success btn-label right ms-auto"
                                        onClick={() => {
                                            if (!formData.patente) {
                                                setPatenteError('Este campo es obligatorio');
                                                return;
                                            }
                                            if (patenteLookupResult !== 'found') {
                                                if (patenteLookupResult === 'not_found') {
                                                    setShowPatenteError(true);
                                                }
                                                return;
                                            }
                                            setActiveStep(activeStep + 1);
                                        }}
                                        disabled={saving || generandoPdf || ownerRutValidation === 'invalid'}
                                    >
                                        Siguiente
                                        <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                                    </button>
                                </div>
                            </>
                        )}

                        {activeStep === 1 && (
                            <>
                                {!personasIsLoading ? (
                                    <ContactSection
                                        formData={formData}
                                        onChange={handleInputChange}
                                        showPatente={false}
                                        errors={contactErrors}
                                    />
                                ) : <></>}

                                <div className="d-flex align-items-start gap-3 mt-4">
                                    <button type="button" className="btn btn-light btn-label" onClick={() => setActiveStep(activeStep - 1)} disabled={saving || generandoPdf}>
                                        <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>
                                        Anterior
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-success btn-label right ms-auto"
                                        onClick={() => {
                                            const errors = {};
                                            if (!(formData.contacto || '').trim()) errors.contacto = 'Este campo es obligatorio';
                                            if (!(formData.email || '').trim()) errors.email = 'Este campo es obligatorio';
                                            if (!(formData.telefono || '').trim()) errors.telefono = 'Este campo es obligatorio';
                                            if (Object.keys(errors).length > 0) {
                                                setContactErrors(errors);
                                                return;
                                            }
                                            setContactErrors({});
                                            setActiveStep(activeStep + 1);
                                        }}
                                        disabled={saving || generandoPdf}
                                    >
                                        Siguiente
                                        <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                                    </button>
                                </div>
                            </>
                        )}

                        {activeStep === 2 && (
                            <>
                                <InventorySection
                                    inventory={formData.inventario}
                                    sinInventario={formData.sin_inventario}
                                    onInventoryChange={(field, value) => {
                                        if (field === 'observaciones') {
                                            setFormData(prevData => ({
                                                ...prevData,
                                                inventario: {
                                                    ...prevData.inventario,
                                                    observaciones: value
                                                }
                                            }));
                                        } else {
                                            setFormData(prevData => ({
                                                ...prevData,
                                                inventario: {
                                                    ...prevData.inventario,
                                                    [field]: value
                                                }
                                            }));
                                        }
                                        setInventoryError('');
                                    }}
                                    onSinInventarioChange={(e) => {
                                        const checked = e.target.checked;
                                        setFormData(prevData => ({
                                            ...prevData,
                                            sin_inventario: checked,
                                            inventario: checked ? {
                                                plumillas: null,
                                                radio: null,
                                                panel_radio: null,
                                                herramientas: null,
                                                gata: null,
                                                extintor: null,
                                                botiquin: null,
                                                permiso_circulacion: null,
                                                libro_garantia: null,
                                                encendedor: null,
                                                accesorios: null,
                                                neumatico_repuesto: null,
                                                tapa_rueda: null,
                                                cubre_pisos: null,
                                                observaciones: ''
                                            } : prevData.inventario
                                        }));
                                        setInventoryError('');
                                    }}
                                    error={inventoryError}
                                />

                                <div className="d-flex align-items-start gap-3 mt-4">
                                    <button type="button" className="btn btn-light btn-label" onClick={() => setActiveStep(activeStep - 1)} disabled={saving || generandoPdf}>
                                        <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>
                                        Anterior
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-success btn-label right ms-auto"
                                        onClick={() => {
                                            if (!formData.sin_inventario) {
                                                const INVENTORY_FIELDS = [
                                                    'plumillas', 'radio', 'panel_radio', 'herramientas',
                                                    'gata', 'extintor', 'botiquin', 'permiso_circulacion',
                                                    'libro_garantia', 'encendedor', 'accesorios',
                                                    'neumatico_repuesto', 'tapa_rueda', 'cubre_pisos',
                                                ];
                                                const faltantes = INVENTORY_FIELDS.filter(f => formData.inventario[f] === null || formData.inventario[f] === undefined);
                                                if (faltantes.length > 0) {
                                                    setInventoryError('Complete todos los ítems del inventario (SÍ o NO).');
                                                    return;
                                                }
                                            }
                                            setInventoryError('');
                                            setActiveStep(activeStep + 1);
                                        }}
                                        disabled={saving || generandoPdf}
                                    >
                                        Siguiente
                                        <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                                    </button>
                                </div>
                            </>
                        )}

                        {activeStep === 3 && (
                            <>
                                <DamageSection
                                    danos={formData.danos}
                                    sinDanos={formData.sin_danos}
                                    sucio={formData.sucio}
                                    onDamagesChange={(data) => {
                                        handleDanosChange(data);
                                        setDamageError('');
                                    }}
                                    onSinDanosChange={(e) => {
                                        const checked = e.target.checked;
                                        if (checked) {
                                            setFormData(prevData => ({
                                                ...prevData,
                                                sin_danos: checked,
                                                danos: [],
                                            }));
                                        } else {
                                            setFormData(prevData => ({
                                                ...prevData,
                                                sin_danos: checked
                                            }));
                                        }
                                        setDamageError('');
                                    }}
                                    onSucioChange={(e) => {
                                        const checked = e.target.checked;
                                        setFormData(prevData => ({
                                            ...prevData,
                                            sucio: checked
                                        }));
                                    }}
                                    error={damageError}
                                />

                                <div className="d-flex align-items-start gap-3 mt-4">
                                    <button type="button" className="btn btn-light btn-label" onClick={() => setActiveStep(activeStep - 1)} disabled={saving || generandoPdf}>
                                        <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>
                                        Anterior
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-success btn-label right ms-auto"
                                        onClick={() => {
                                            if (!formData.sin_danos && (!Array.isArray(formData.danos) || formData.danos.length === 0)) {
                                                setDamageError('Marque al menos un daño en la imagen del vehículo.');
                                                return;
                                            }
                                            setDamageError('');
                                            setActiveStep(activeStep + 1);
                                        }}
                                        disabled={saving || generandoPdf}
                                    >
                                        Siguiente
                                        <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                                    </button>
                                </div>
                            </>
                        )}

                        {activeStep === 4 && (
                            <>
                                <div className="d-flex align-items-center my-2">
                                    <div className="flex-grow-1 border-top"></div>
                                    <span className="mx-3 text-muted fw-bold">Imágenes</span>
                                    <div className="flex-grow-1 border-top"></div>
                                </div>
                                <ImageUploader
                                    onImagesChange={handleImagesChange}
                                    maxImages={10}
                                    existingImages={formData.imagenes}
                                    onCameraOpen={setCameraOpen}
                                />

                                <div className="d-flex align-items-start gap-3 mt-4">
                                    <button type="button" className="btn btn-light btn-label" onClick={() => setActiveStep(activeStep - 1)} disabled={saving || generandoPdf}>
                                        <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>
                                        Anterior
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-success btn-label right ms-auto"
                                        onClick={() => setActiveStep(activeStep + 1)}
                                        disabled={saving || generandoPdf}
                                    >
                                        Siguiente
                                        <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                                    </button>
                                </div>
                            </>
                        )}

                        {activeStep === 5 && (
                            <>
                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="cliente">Cliente</Label>
                                            <Input
                                                type="text"
                                                id="contacto"
                                                name="contacto"
                                                value={formData.contacto}
                                                onChange={handleInputChange}
                                                placeholder="Ej: Jorge Gonzalez"
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="nombre_recepcionista">Recepcionista</Label>
                                            <Input
                                                type="text"
                                                id="nombre_recepcionista"
                                                name="nombre_recepcionista"
                                                value={formData.nombre_recepcionista}
                                                onChange={handleInputChange}
                                                placeholder={`Ej: Miguel Tapia`}
                                                required
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <SignatureSection
                                    firmaCliente={formData.firma_cliente}
                                    firmaRecepcionista={formData.firma_recepcionista}
                                    onSignatureChange={(field, data) => {
                                        if (field === 'firma_cliente') {
                                            setFormData(prev => ({
                                                ...prev,
                                                firma_cliente: data
                                            }));
                                            console.log(formData);
                                        } else if (field === 'firma_recepcionista') {
                                            setFormData(prev => ({
                                                ...prev,
                                                firma_recepcionista: data
                                            }));
                                            console.log(formData);
                                        }
                                    }}
                                />

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="select_quien_retira">Quien retira?</Label>
                                            <Select
                                                id="select_quien_retira"
                                                name="select_quien_retira"
                                                placeholder="Seleccione..."
                                                value={selectQuienRetira}
                                                onChange={setSelectQuienRetira}
                                                options={[
                                                    { value: 'propietario', label: 'Propietario' },
                                                    { value: 'otro', label: 'Otro' }
                                                ]}
                                                onFocus={(e) => {
                                                    e.target.readOnly = true;
                                                }}
                                            />
                                        </FormGroup>
                                    </div>
                                    {selectQuienRetira && selectQuienRetira.value === 'otro' ? (
                                        <div className="col-6">
                                            <FormGroup>
                                                <Label for="quien_retira">Otro</Label>
                                                <Input
                                                    type="text"
                                                    id="quien_retira"
                                                    name="quien_retira"
                                                    value={formData.quien_retira}
                                                    onChange={handleInputChange}
                                                    placeholder={`Ej: Nombre de la persona`}
                                                    required
                                                />
                                            </FormGroup>
                                        </div>) : null}
                                </div>

                                <div className="d-flex align-items-start gap-3 mt-4">
                                    <button type="button" className="btn btn-light btn-label" onClick={() => setActiveStep(activeStep - 1)} disabled={saving || generandoPdf}>
                                        <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>
                                        Anterior
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-success ms-auto"
                                        onClick={handleSubmit}
                                        disabled={generandoPdf || saving || ownerRutValidation === 'invalid'}
                                    >
                                        {saving ? (
                                            <><i className="ri-loader-4-line ri-spin-line me-1"></i> Guardando...</>
                                        ) : generandoPdf ? (
                                            <><i className="ri-loader-4-line ri-spin-line me-1"></i> Generando PDF...</>
                                        ) : (
                                            <><i className="ri-save-line me-1"></i> Guardar Recepción</>
                                        )}
                                    </button>
                                </div>
                            </>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        {ownerRutValidation === 'invalid' && (
                            <ErrorAlert
                                error="El RUT del propietario no existe. Cree la persona o corrija el RUT."
                                onDismiss={undefined}
                            />
                        )}
                        {saveMessage && (
                            <ErrorAlert
                                error={saveMessage}
                                onDismiss={saveMessage.includes('exitosamente') ? undefined : () => setSaveMessage('')}
                            />
                        )}
                        {validationError && (
                            <ErrorAlert
                                error={validationError}
                                onDismiss={undefined}
                            />
                        )}
                    </ModalFooter>
                </Form>
            </div>
            <ConfirmCloseModal
                isOpen={showConfirm}
                toggle={() => setShowConfirm(false)}
                onConfirm={handleConfirmClose}
            />
        </Modal>
    );
};

export default ModalCrearRecepcionVehiculo;
